import { dialogCardCoverAttrs } from "../../../lib/responsive-story-images.js";
import { pickListCardTaglineText } from "../../../lib/reader-tagline.js";
import LlCardLocaleText from "../ll-card-locale-text.marko";
import LlFavoriteHeart from "../ll-favorite-heart.marko";

<div
  class="card card--dialog ll-card-shell"
  data-card-slug=input.item.slug
  data-content-id=(input.item.contentId || input.item.slug)
  data-stats=(input.item.stats ? JSON.stringify(input.item.stats) : null)
  data-card-level=(input.item.level || '').toLowerCase()
  data-plot-primary-category=(input.item.plotPrimaryCategory || '')
  data-plot-category-score=(input.item.plotCategoryScore != null ? input.item.plotCategoryScore : '')
  data-plot-categories=(input.item.plotCategories ? JSON.stringify(input.item.plotCategories) : '[]')
>
  <a href=`${input.basePath}/${input.item.slug}` class="card__link" style="text-decoration:none">
    <div class="card__image-wrap">
      <if=input.item.coverImage>
        <for|cover| of=[dialogCardCoverAttrs(input.item.coverImage)]>
          <img
            src=cover.src
            srcset=(cover.srcSet || null)
            sizes=(cover.sizes || null)
            alt=(input.item.targetTitle || input.item.title)
            class="card__image"
            width=cover.width
            height=cover.height
            loading="lazy"
            decoding="async"
            data-ll-responsive-cover=(cover.responsive ? "1" : null)
            onError="this.style.display='none';this.parentElement.innerHTML='<div class=card__image-placeholder>💬</div>'"
          >
        </for>
      </if>
      <else>
        <div class="card__image-placeholder">💬</div>
      </else>
    </div>
    <div class="card__body">
      <div class="card__meta card__meta--story">
        <div class="ll-card-level-stripe-host" data-level-stripe tabindex="-1" aria-hidden="true"></div>
      </div>
      <if=(input.item.learnerTitle || input.item.translatedTitle)>
        <p class="title-aid">
          <LlCardLocaleText
            text=(input.item.learnerTitle || input.item.translatedTitle)
            item=input.item
            slot="titleAid"
            sectionKey=(input.sectionKey || "dialogs")
            uiLang=$global.uiLang
            targetCode=$global.targetCode
          />
        </p>
        <h2 class="card__title">
          <span data-ll-card-title-slot>
            <LlCardLocaleText
              text=(input.item.targetTitle || input.item.title)
              item=input.item
              slot="title"
              sectionKey=(input.sectionKey || "dialogs")
              uiLang=$global.uiLang
              targetCode=$global.targetCode
            />
          </span>
        </h2>
      </if>
      <else>
        <h2 class="card__title">
          <span data-ll-card-title-slot>
            <LlCardLocaleText
              text=(input.item.targetTitle || input.item.title)
              item=input.item
              slot="title"
              sectionKey=(input.sectionKey || "dialogs")
              uiLang=$global.uiLang
              targetCode=$global.targetCode
            />
          </span>
        </h2>
      </else>
      <p class="card__teaser">
        <span data-ll-card-teaser-slot>
          <LlCardLocaleText
            text=(pickListCardTaglineText(input.item))
            item=input.item
            slot="teaser"
            sectionKey=(input.sectionKey || "dialogs")
            uiLang=$global.uiLang
            targetCode=$global.targetCode
          />
        </span>
      </p>
      <if=input.item.name_1 || input.item.name_2>
        <p style="font-size:0.8rem;color:var(--color-text-muted);margin-top:4px">
          <if=input.item.name_1>${input.item.name_1}</if>
          <if=input.item.name_1 && input.item.name_2> · </if>
          <if=input.item.name_2>${input.item.name_2}</if>
        </p>
      </if>
      <div class="ll-card-stripe ll-card-stripe--bottom" data-stripe-bottom aria-hidden="true"></div>
    </div>
  </a>
  <LlFavoriteHeart contentId=(input.item.contentId || input.item.slug)/>
</div>
